// Wording helpers for the sign-in screens. The screens never assume a number: durations come from the server.

// "1 minute" / "N minutes" under 2 hours, "1 hour" / "N hours" from 2 hours, rounded. '' for a missing or non-positive
// value, so the caller leaves the sentence out.
export const formatDuration = (seconds) => {
    if (typeof seconds !== 'number' || !Number.isFinite(seconds) || seconds <= 0) { return '' }
    if (seconds < 7200) {
        const minutes = Math.max(1, Math.round(seconds / 60))
        return minutes === 1 ? '1 minute' : `${minutes} minutes`
    }
    const hours = Math.round(seconds / 3600)
    return hours === 1 ? '1 hour' : `${hours} hours`
}
